import React from "react";
import "../Css/nurture.css";
import "../Css/wesupport.css";
import SafetyNurture from "../F-img/Safety-and-Nurture.png";
import BelongingTherapeuticCare from "../F-img/Therapeutic-Care.png";
import ProcessandProgress from "../F-img/Process-and-Progress.png";
import FamilyRelationships from "../Img/Final-images/Family-Time-Relationships.png";
import LeadershipStaffing from "../Img/Final-images/Leadership-Staffing.jpg";
import Safeguarding from "../Img/Final-images/Safeguarding-First.jpg";
import OurHomeImg from "../Img/Final-images/Our-Homes-Page.jpg";
import LocalAuthorities from "../Img/Final-images/Local-Authorities.jpg";

import BirminghamLogo from "../Img/Local Council/birmingham-logo.png";
import CoventrycouncilLogo from "../Img/Local Council/coventry-council.png";
import DudleyLogo from "../Img/Local Council/dudley-logo.png";
import HampshireCountyLogo from "../Img/Local Council/Hampshire-County-Council-Logo.png";
import HerefordshireLogo from "../Img/Local Council/herefordshire-logo.png";
import IewmLogo from "../Img/Local Council/iewm.png";
import OfstedLogo from "../Img/Local Council/Ofsted-logo.png";
import SandwellLogo from "../Img/Local Council/sandwell-logo.png";
import ShropshireLogo from "../Img/Local Council/shropshire-logo.png";
import SolihullLogo from "../Img/Local Council/solihull-logo.png";
import StokeLogo from "../Img/Local Council/stoke-logo.png";
import TelfordLogo from "../Img/Local Council/telford-logo.png";
import WalsallLogo from "../Img/Local Council/walsall-logo.png";
import WarwickshireLogo from "../Img/Local Council/warwickshire-logo.png";
import WolverhamptonLogo from "../Img/Local Council/wolverhampton-logo.png";
import WorcestershireLogo from "../Img/Local Council/worcestershire-logo.png";

function Nurture() {
  return (
    <>
      <section className="Nurture-section">
        <div className="container">
          <h3 className="sub-heading pt-5 text-center">
            What Makes Our Care Different
          </h3>
          <p className="text-center ">
            A calm, consistent, relationship led approach
          </p>

          <p className="text-justify">
            Children thrive when the adults around them are patient,predictable,
            and emotionally available. Across all our homes, staff are trained
            to understand behavior as communication and to respond with empathy,
            structure, and clarity. We priorities connection before correction.
            This helps children build trust, develop emotional regulation, and
            feel confident expressing their needs. Progress is nurtured through
            stability, routine, and adults who remain consistent even during
            challenging moments.
          </p>
          {/*
          <div className="nurture-grid mt-5 pt-3">
            <div className="nurture-card">
              <span className="nurture-circle">N</span>
              <p>
                Be inspired to reach for the stars! Have a number one fan who
                cheers them on.
              </p>
            </div>
            <div className="nurture-card highlight">
              <span className="nurture-circle">U</span>
              <p>
                Be given the environment, unity of support and love to simply be
                a child!
              </p>
            </div>
            <div className="nurture-card">
              <span className="nurture-circle">R</span>
              <p>
                Be surrounded by people who give them rooted foundations to
                overcome challenges.
              </p>
            </div>
            <div className="nurture-card highlight">
              <span className="nurture-circle">T</span>
              <p>
                Be given the opportunity to thrive and create childhood memories
                for life.
              </p>
            </div>
            <div className="nurture-card">
              <span className="nurture-circle">U</span>
              <p>
                Be loved, nurtured and cared for unconditionally — to the moon
                and back.
              </p>
            </div>
            <div className="nurture-card highlight">
              <span className="nurture-circle">R</span>
              <p>Feel protected, safe and reassured. Always.</p>
            </div>
            <div className="nurture-card">
              <span className="nurture-circle">E</span>
              <p>
                Be given emotional and physical support tailored to each
                individual.
              </p>
            </div>
          </div>*/}
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front">
                    <img
                      src={Safeguarding}
                      alt="Safeguarding First"
                      className="img-fluid card-img"
                    />
                    <div className="card-overlay">
                      <h4>Safeguarding First</h4>
                    </div>
                  </div>
                  {/* BACK */}
                  <div className="flip-card-back">
                    <h4>Safeguarding is central to everything we do</h4>
                    <p className="text-white">
                      We operate robust safeguarding systems aligned with
                      legislation, statutory guidance, and regulatory
                      frameworks. Staff receive ongoing training to ensure they
                      can identify concerns early, respond appropriately, and
                      maintain a culture where children’s safety and rights are
                      always prioritized. Children are supported to understand
                      their rights, feel confident raising concerns, and access
                      independent support whenever they need it.
                    </p>
                  </div>
                </div>
                {/* MOBILE CONTENT (always visible) */}
                <div className="mobile-details">
                  <h4>Safeguarding First</h4>

                  <strong>Safeguarding is central to everything we do</strong>
                  <p>
                    We operate robust safeguarding systems aligned with
                    legislation, statutory guidance, and regulatory frameworks.
                    Staff receive ongoing training to ensure they can identify
                    concerns early, respond appropriately, and maintain a
                    culture where children’s safety and rights are always
                    prioritized. Children are supported to understand their
                    rights, feel confident raising concerns, and access
                    independent support whenever they need it.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front">
                    <img
                      src={OurHomeImg}
                      alt="Our Hom"
                      className="img-fluid card-img"
                    />
                    <div className="card-overlay">
                      <h4>Our Homes</h4>
                    </div>
                  </div>
                  {/* BACK */}
                  <div className="flip-card-back">
                    <h4>
                      Warm, nurturing environments designed around children’s
                      needs
                    </h4>
                    <p className="text-white">
                      Each Affinity home is carefully designed to feel
                      welcoming, calm, and homely. While every home has its own
                      identity and Statement of Purpose, all operate within the
                      same governance, safeguarding, and quality framework. Our
                      homes provide emotional safety, predictable routines, and
                      opportunities for children to develop confidence,
                      independence, and a sense of belonging.
                    </p>
                  </div>
                </div>
                {/* MOBILE CONTENT (always visible) */}
                <div className="mobile-details">
                  <h4>Our Homes</h4>

                  <strong>
                    Warm, nurturing environments designed around children’s
                    needs
                  </strong>
                  <p>
                    Each Affinity home is carefully designed to feel welcoming,
                    calm, and homely. While every home has its own identity and
                    Statement of Purpose, all operate within the same
                    governance, safeguarding, and quality framework. Our homes
                    provide emotional safety, predictable routines, and
                    opportunities for children to develop confidence,
                    independence, and a sense of belonging.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front">
                    <img
                      src={LocalAuthorities}
                      alt="Local Authorities"
                      className="img-fluid card-img"
                    />
                    <div className="card-overlay">
                      <h4>Working With Local Authorities</h4>
                    </div>
                  </div>
                  {/* BACK */}
                  <div className="flip-card-back">
                    <h4>Collaborative, transparent partnerships</h4>
                    <p className="text-white">
                      We work closely with placing authorities, education
                      providers, and health professionals to ensure each child
                      receives coordinated, consistent support. Our approach is
                      open, reflective, and centered on achieving the best
                      possible outcomes for every child.
                    </p>
                  </div>
                </div>
                {/* MOBILE CONTENT (always visible) */}
                <div className="mobile-details">
                  <h4>Working With Local Authorities</h4>

                  <strong>Collaborative, transparent partnerships</strong>
                  <p>
                    We work closely with placing authorities, education
                    providers, and health professionals to ensure each child
                    receives coordinated, consistent support. Our approach is
                    open, reflective, and centered on achieving the best
                    possible outcomes for every child.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="logo-section pt-5 Local-Authorities">
            <div className="container">
              <h3 className="sub-heading pb-3 text-center">
                Our Local Authorities
              </h3>

              <div className="logo-slider">
                <div className="logo-track">
                  {/* ORIGINAL */}
                  <img src={BirminghamLogo} alt="Birmingham" />
                  <img src={CoventrycouncilLogo} alt="Coventry" />
                  <img src={DudleyLogo} alt="Dudley" />
                  <img src={HampshireCountyLogo} alt="Hampshire" />
                  <img src={HerefordshireLogo} alt="Herefordshire" />
                  <img src={IewmLogo} alt="IEWM" />
                  <img src={OfstedLogo} alt="Ofsted" />
                  <img src={SandwellLogo} alt="Sandwell" />
                  <img src={ShropshireLogo} alt="Shropshire" />
                  <img src={SolihullLogo} alt="Solihull" />
                  <img src={StokeLogo} alt="Stoke" />
                  <img src={TelfordLogo} alt="Telford" />
                  <img src={WalsallLogo} alt="Walsall" />
                  <img src={WarwickshireLogo} alt="Warwickshire" />
                  <img src={WolverhamptonLogo} alt="Wolverhampton" />
                  <img src={WorcestershireLogo} alt="Worcestershire" />

                  {/* DUPLICATE for infinite loop */}
                  <img src={BirminghamLogo} alt="Birmingham" />
                  <img src={CoventrycouncilLogo} alt="Coventry" />
                  <img src={DudleyLogo} alt="Dudley" />
                  <img src={HampshireCountyLogo} alt="Hampshire" />
                  <img src={HerefordshireLogo} alt="Herefordshire" />
                  <img src={IewmLogo} alt="IEWM" />
                  <img src={OfstedLogo} alt="Ofsted" />
                  <img src={SandwellLogo} alt="Sandwell" />
                  <img src={ShropshireLogo} alt="Shropshire" />
                  <img src={SolihullLogo} alt="Solihull" />
                  <img src={StokeLogo} alt="Stoke" />
                  <img src={TelfordLogo} alt="Telford" />
                  <img src={WalsallLogo} alt="Walsall" />
                  <img src={WarwickshireLogo} alt="Warwickshire" />
                  <img src={WolverhamptonLogo} alt="Wolverhampton" />
                  <img src={WorcestershireLogo} alt="Worcestershire" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="chilldren-help">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="therapeutic-box-wrap">
                <h2 className="sub-heading ">Who We Support</h2>
                <p className="support-text">
                  The home supports children and young people who may present
                  with:
                </p>

                <ul className="quality-list mt-4">
                  <li>Emotional and behavioural difficulties</li>
                  <li>Attachment challenges</li>
                  <li>Trauma-related behaviours</li>
                  <li>Difficulties engaging in education</li>
                </ul>
                <p className="support-text">
                  Placements are accepted only where the home can provide
                  stability, safety, and appropriate support.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="therapeutic-box-wrap">
                <h2 className="sub-heading ">Therapeutic & Behavior Support</h2>
                <p className="support-text">
                  Care is informed by trauma aware practice, including Empathic
                  Behavior Management.
                </p>

                <ul className="quality-list mt-4">
                  <li>De escalation</li>
                  <li>Emotional regulation</li>
                  <li>Relationship repair</li>
                  <li>Reflective practice</li>
                </ul>
                <p className="support-text">
                  Where appropriate, therapeutic consultation supports staff
                  understanding and consistency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="support-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="sub-heading text-center">The Home Environment</h2>
              <p className="support-text">
                The home is designed to feel warm, comfortable, and welcoming.
                Children are encouraged to personalize their bedrooms and
                contribute to decisions about communal areas, helping them
                develop a sense of ownership and belonging.
              </p>
              <p>
                The environment supports privacy, safety, and emotional
                wellbeing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="container">
          <h2 className="sub-heading text-center">Education & Health</h2>
          <p className="text-center">
            Education and health are prioritized within the home. We work in
            partnership with Children are supported to attend education, engage
            in learning, and access healthcare appointments as required.
          </p>
          <div className="row g-4">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon">🏠</div>
                <h5 className="feature-title">Homely Environment</h5>
                <p className="feature-text">
                  Provides care in a nurturing and welcoming home setting.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon">👨‍💼</div>
                <h5 className="feature-title">Experienced Manager</h5>
                <p className="feature-text">
                  Each home is led by a qualified and experienced Registered
                  Manager.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon">📋</div>
                <h5 className="feature-title">Statement of Purpose</h5>
                <p className="feature-text">
                  Operates under its own clear Statement of Purpose and care
                  policies.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="feature-card">
                <div className="feature-icon">❤️</div>
                <h5 className="feature-title">Individual Care Planning</h5>
                <p className="feature-text">
                  Supports children through personalised and individual care
                  plans.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 Therapy-Access">
        <div className="container">
          <div className="row">
            <div className="col-md-6 Affinity-Childrens text-white">
              <h2 className="sub-heading text-white">
                Family Time & Relationships
              </h2>
              <p className="support-text text-white">
                Children are supported to maintain and develop positive
                relationships with family and friends, subject to
              </p>

              <ul className="quality-list mt-4">
                <li className=" text-white"> Risk assessment</li>
                <li className=" text-white">Placing authority agreements</li>
                <li className=" text-white">Individual care plans</li>
              </ul>
              <p className="support-text text-white">
                Family time arrangements are carefully planned to promote
                emotional safety and stability
              </p>
            </div>

            <div className="col-md-6">
              <img
                src={FamilyRelationships}
                alt="Family Time & Relationships"
                className="w-100 family-relationships m-view"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img
                src={LeadershipStaffing}
                alt="Leadership & Staffing"
                className="w-100 Leadership-Staffing m-view"
              />
            </div>
            <div className="col-md-6">
              <h2 className="sub-heading hmv">Leadership & Staffing</h2>
              <p className="support-text">
                Each home is led by a Registered Manager who is supported by a
                skilled and experienced staff team.
              </p>

              <ul className="quality-list mt-4">
                <li> Regular supervision</li>
                <li>Ongoing training</li>
                <li>Annual appraisals</li>
                <li>Support to develop professionally</li>
              </ul>
              <p className="support-text">
                This ensures care is delivered safely, consistently, and in line
                with regulatory expectations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Nurture;
